import { Component, OnInit } from '@angular/core';
import { AnnouncementModel, AnnouncementQuery, AnnouncementService } from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';

@Component({
  selector: 'fgb-news-page',
  templateUrl: './news-page.component.html',
  styleUrl: './news-page.component.scss',
})
export class NewsPageComponent implements OnInit {
  announcements$: Observable<AnnouncementModel[]>;

  constructor(private announcementService: AnnouncementService, private announcementQuery: AnnouncementQuery) {}

  ngOnInit() {
    firstValueFrom(this.announcementService.fetchAnnouncements());
    this.announcements$ = this.announcementQuery.announcements();
  }
}
